
import { BsPatchQuestionFill } from 'react-icons/bs'
import { faqs } from '../../data'
import SectionHead from '../SectionHead'
import FAQ from '../FAQ'

const FAQs = () => {
  return (
    <section className="faqs">
        <div className="container faqs__container">
            <SectionHead sectionName="faqs" icon={<BsPatchQuestionFill/>} title="Got Questions?"/>
            <div className="faqs__wrapper">
                {
                    faqs.map(({id, question, answer}) => {
                        return <FAQ key={id} question={question} answer={answer}/>
                    })
                }
            </div>
        </div>
    </section>
  )
}

export default FAQs